<template>
  <h2 class="tw-text-3.25xl tw-text-neutral-900 tw-leading-none tw-font-bold">
    <slot />
  </h2>
</template>
